import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-102ce8c8")
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://oswap.io/img/logo.4fab4f31.svg",
  width: "36",
  alt: "logo"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
_popScopeId()

import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

function goToHome() {
  router.push({
    name: "Home",
  });
}

function goToSwap(): void {
  const a = document.createElement("a");
  a.href = "https://oswap.io";
  a.target = "_blank";
  a.click();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { style: {"display":"flex"} }, [
      _createElementVNode("div", {
        style: {"cursor":"pointer"},
        onClick: goToHome
      }, _hoisted_3),
      _createElementVNode("div", { class: "menu-items" }, [
        _createElementVNode("span", {
          class: "active",
          onClick: goToHome
        }, "Pools"),
        _createElementVNode("span", { onClick: goToSwap }, "Swap")
      ])
    ])
  ]))
}
}

})